import { InputLabel, InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";

export const NewConnectionConnectionDialogSearchInput = ({
  searchValue,
  setSearchValue,
}: {
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
}) => {
  return (
    <>
      <InputLabel className="mb-1">New Message</InputLabel>
      <InputContainer className="sticky">
        <InputText
          required={false}
          placeholder={"Search..."}
          onChange={(e) => setSearchValue(e.target.value.toLowerCase())}
          value={searchValue}
        />
      </InputContainer>
    </>
  );
};
